// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b85c4dbc","239":"3ace8617","488":"1f5c7ad1","667":"d572736b"}[chunkId] + ".chunk.js";
};